module.exports = __webpack_public_path__ + "images/rating-drops-black-1a5b883b.svg";